<script setup lang="ts">
withDefaults(defineProps<{ level: string; jobName?: string; levelLabel?: string }>(), { levelLabel: 'Lv.' })
</script>

<template>
  <span class="widget-player" :title="`${level === '--' ? '--' : `${levelLabel} ${level}`}${jobName ? ` · ${jobName}` : ''}`">
    <span class="widget-player-level">{{ level === '--' ? '' : `${levelLabel} ` }}<b>{{ level }}</b></span>
    <span v-if="level !== '--' && jobName" class="widget-player-job"><span aria-hidden="true">·</span><span class="widget-player-job-name">{{ jobName }}</span></span>
  </span>
</template>
